import { NgModule } from '@angular/core';
import { PurchaseRequisitionActiveDirective } from './purchase-requisition-active.directive';

@NgModule({
    declarations: [PurchaseRequisitionActiveDirective],
    exports: [PurchaseRequisitionActiveDirective],
})
export class PurchaseRequisitionActiveModule {}
